'use strict';

function CommentStats (stats) {
  this.tpl = {
    stats: '[data-template="community-comment-stats"]'
  };

  this.refs = {
    stats: '[data-ref="community-comment-stats"]'
  };

  this.stats = stats;
  this.html;
}

CommentStats.prototype.buildHTML = function () {
  var html = document.querySelector(this.tpl.stats).cloneNode(true);
  html.setAttribute('data-ref', html.getAttribute('data-template'));
  html.removeAttribute('data-template');

  var stats = parseInt(this.stats);
  var suffix = ' Comentario';
  if (stats > 1) suffix = ' Comentarios';
  html.firstElementChild.textContent = this.stats + suffix;

  return html;
};

CommentStats.prototype.getHTML = function () {
  if (!this.html) this.html = this.buildHTML();
  return this.html;
};

module.exports = CommentStats;



//////////////////
// WEBPACK FOOTER
// ./_js/comments/comment-stats.js
// module id = 35
// module chunks = 0